const vn = {
    num: 'Số',
    operator: 'Người vận hành',
    oprtTime: 'Thời gian hoạt động',
    oprtType: 'Loại hoạt động',
    orderSource: 'Nguồn order',
    orderStatus: 'Trạng thái đặt hàng',
    orderType: 'Loại lệnh',
    printCount: 'Số lần in',
    prdctName: 'Tên sản phẩm',
    quantity: 'Số lượng',
    delTip1: 'Bạn có chắc chắn muốn xóa danh sách {{type}} kho này không?',
    delTip2: 'Sau khi xóa, dữ liệu {{type}} kho này không thể phục hồi',
    delSucc: 'Xóa thành công',
    delFail: 'Lỗi xóa,{{content}}',
    orderDetails: 'Chi tiết đặt hàng',
    cancel: 'Hủy bỏ',
    confirm: 'Xác định',
    confirm2: 'Xác định',
    basicData: 'Dữ liệu cơ bản',
    goods: 'Hàng hóa',
    verificaFailed: 'Kiểm tra thất bại',
    quantityTip1: 'Số lượng sản phẩm phải lớn hơn 0',
    quantityTip2: 'Tên sản phẩm và định dạng số lượng phải chính xác',
    aplicatForm: 'Đơn đăng ký',
    prdctList: 'Danh sách sản phẩm',
    fillQuantity: 'Vui lòng điền vào {{type}} số lượng',
    next: 'Tiếp theo',
    noGood: 'Nhà kho không có sản phẩm này.',
    modificatFailed: 'Sửa đổi thất bại',
    tradeName: 'Tên sản phẩm',
    brand: 'Mô hình',
    desc: 'Mô tả',
    unit: 'Đơn vị',
    inboundOprt: 'Tôi muốn vào kho.',
    outboundOprt: 'Tôi sẽ ra khỏi kho.',
    addFailed: 'Lỗi thêm',
    prdctSource: 'Nguồn sản phẩm',
    basicInfo: 'Thông tin cơ bản',
    creator: "Người tạo đơn",
    createdAt: "Thời gian tạo đơn",
    preparedBy: 'Người lập',
    preparationTime: 'Thời gian lập',
    operationSource: 'Nguồn hoạt động',
    operationStatus: 'Trạng thái hoạt động',
    inTransit: 'Đang vận chuyển',
    inboundCompleted: 'Đã nhập kho',
    preparing: 'Đang chuẩn bị',
    outboundCompleted: 'Đã xuất kho',
    modifyFail: 'Sửa đổi hàng tồn kho thất bại',
    sameCodeTip1: 'Có cùng mã vạch, vui lòng kiểm tra',
    view: 'Xem thêm',
    noScanOrder: 'Danh sách quét không tồn tại',
    temStorage: 'Lưu trữ tạm thời',
    repeatInTip: 'Mã vạch {{code}} đã tồn tại và không thể nhập lại vào thư viện.',
    plFillInData: 'Vui lòng điền thông tin',
    plFillInDataCompletely: 'Vui lòng điền đầy đủ thông tin!',
    tip: 'Mẹo',
    cancelTip1: 'Hiện tại đã có dữ liệu tồn tại, xác nhận hủy bỏ chưa?',
    sameCodeSel: 'Lặp lại lựa chọn mã vạch',
    sameCode: 'Lặp lại mã vạch:',
    plSelSpecifiedProduct: 'Vui lòng chọn sản phẩm được chỉ định để hoạt động:',
    productTitle: 'Sản phẩm',
    productCode: 'Mã sản phẩm',
    barcode: 'Mã vạch',
    viewCode: 'Xem mã vạch',
    copySuccess: 'Copy thành công!',
    copyFail: 'Sao chép thất bại!',
    codeListWithCount: 'Danh sách mã vạch (tổng cộng: {{count}})',
    copyAll: 'Sao chép một cú nhấp chuột',
    conDelTip1: 'Mã vạch trùng lặp tồn tại trong kho, bạn có xóa mã vạch sau không?',
    conDelTip2: 'Mã vạch này không tồn tại trong kho hàng, bạn có xóa mã vạch sau không?',
    operationSucc: 'Hoạt động thành công',
    saveSucTip: 'Lưu trữ tạm thời thành công, có thể hoạt động trên dữ liệu trong danh sách đặt hàng!',
    saveFailTip: 'Lỗi lưu tạm thời，{{err}}',
    fetchBarcodesFailt: 'Truy vấn mã vạch không thành công，{{err}}',
    searchPl: 'Vui lòng nhập từ khóa để tìm kiếm',
    searchByOrderNumber: 'Vui lòng nhập số đơn hàng để tìm kiếm',
    startTime: 'Thời gian bắt đầu',
    endTime: 'Thời gian kết thúc',
    confirmTip: 'Mã vạch sau đây không phù hợp với hàng hóa trong kho',
    serialMumber: 'Số sê-ri',
    barcodesNumber: 'Số lượng mã vạch',
    addDataTip: 'Vui lòng thêm dữ liệu trước',
    selectChangeTypePl: 'Vui lòng chọn loại hoạt động',
    preTime: 'Thời gian giao hàng',
    confirmedTime: 'Thời gian thực tế nhập/xuất kho',
    editOrder: 'Sửa lệnh',
    quantityConfirm: 'Xác nhận số lượng',
    updateOrderSuccess: 'Cập nhật đơn hàng thành công',
    onOrders: 'Đặt hàng số lượng lớn',
    ordersComfirm: 'Xác định đơn đặt hàng số lượng lớn?',
    optErr: "Thao tác thất bại",
    signed: 'Đã ký nhận',
    noChanges: 'Không có thay đổi',
    inOutNo: "Đơn nhập/xuất kho",
    remark: 'Ghi chú',
    saleOut: "Xuất kho bán hàng",
    calcOut: "Tính toán dữ liệu xuất kho",
    saledQty: "Số lượng đã bán",
    productionInCount: "Số lượng nhập kho sản xuất",
    toSaledQty: "Số lượng chờ xuất kho",
    curSaledQty: "Số lượng bán lần này",
    zeroTip: "Ít nhất một vật liệu có số lượng bán lần này lớn hơn 0",
    orderSucc: "Đơn xuất kho bán hàng đã được tạo thành công",
    orderErr: "Tạo đơn xuất kho bán hàng thất bại",
    preOut: "Phân bổ tồn kho",
    needPre: "Vui lòng phân bổ tồn kho cho đơn xuất kho bán hàng trước!",
    preOutSucc: "Đã phân bổ tồn kho thành công",
    preOutErr: "Phân bổ tồn kho thất bại",
    orderContitle: "Xác nhận tạo đơn xuất kho dự kiến cho bán hàng?",
    outOvernum: "Số lượng tồn kho đã sử dụng vượt quá số lượng tồn kho khả dụng",
    isSwap: "Có phải chứng từ chuyển đơn không",
};
export default vn;
